module.exports = __webpack_public_path__ + "TiemposFine-Light.svg?b3ee24804e6ff901f204ad146d148c3d";